import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {
  ActivationEnd,
  Event,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router
} from '@angular/router';
import {BaseService, ConfigurationService, LoadingService} from '@nh/angular-tses';
import {BehaviorSubject, Observable} from 'rxjs';
import {filter} from 'rxjs/operators';

export enum NavigationTarget {
  SUBMISSION = 'SUBMISSION',
  DIARY = 'DIARY',
  POST_DETERMINATION = 'POST_DETERMINATION',
  SPECIALIST_REVIEW = 'SPECIALIST_REVIEW',
  HOME = 'HOME',
  SEARCH = 'SEARCH',
  IMPORT = 'IMPORT',
  ADMIN_PAGE = 'ADMIN_PAGE',
  USER_LOCATIONS = 'USER_LOCATIONS'
}

@Injectable({
  providedIn: 'root'
})
export class RouteService extends BaseService {
  private _routedTo = new BehaviorSubject<NavigationTarget>(null);

  constructor(private _router: Router, snackbar: MatSnackBar, configurationService: ConfigurationService) {
    super(snackbar, configurationService);
    this._subscriptions.push(
      this._router.events.pipe(filter(event => event instanceof ActivationEnd)).subscribe((event: Event) => {
        const activationEnd: ActivationEnd = event as ActivationEnd;
        if (activationEnd.snapshot && activationEnd.snapshot.data && activationEnd.snapshot.data.location) {
          this._routedTo.next(activationEnd.snapshot.data.location);
        }
        // Remove keycloak state from the url:
        window.history.replaceState(null, null, window.location.pathname + window.location.hash);
      }),
      this._router.events
        .pipe(
          filter(
            event =>
              event instanceof NavigationStart ||
              event instanceof NavigationEnd ||
              event instanceof NavigationError ||
              event instanceof NavigationCancel
          )
        )
        .subscribe((event: Event) => {
          LoadingService.setLoadingState(event instanceof NavigationStart);
        })
    );
  }

  /**
   * Returns and observable that emmits a NavigationTarget when one of the NavigationTargets is routed to
   */
  public onRouting(): Observable<NavigationTarget> {
    return this._routedTo.asObservable();
  }
}
